import React from 'react'
import Systemengineer from '../Components/SystemEngineerDashbord/SystemEngineer/Systemengineer'

const SystemengineerPage = () => {
  return (
    <div>
      <Systemengineer/>
    </div>
  )
}

export default SystemengineerPage
